import React from 'react';
import Survey from './Components/survey'
//import GoogleFontLoader from 'react-google-font-loader';


function App() {
  
  //FontLoader();

  return (<Survey/>);
}

export default App;
